import { HttpClient } from "../httpClient";

const httpClient = new HttpClient();

const getFqaList = (data: any) => {
    return httpClient.get(`Home/QAList`, data);
}

const faqService = {
    getFqaList
};

export default faqService;